module.exports = __webpack_public_path__ + "img/28.1413dba5.jpg";